import { useCallback, useMemo } from 'react';

import { useTranslations } from 'js/hooks/i18n';
import { useFormatter } from 'js/hooks/useFormatter';

const suffixes = {
    1: 'st',
    2: 'nd',
    3: 'rd',
    21: 'st',
    22: 'nd',
    23: 'rd',
    31: 'st'
};

/**
 * 15th November 1994
 */
export const useDateWithFullMonth = () => {
    const { formatNumber, getDate } = useFormatter();
    const t = useTranslations('playtech.mobile.system.formatter.');

    const monthsList = useMemo(() => [
        t('january'),
        t('february'),
        t('march'),
        t('april'),
        t('may'),
        t('june'),
        t('july'),
        t('august'),
        t('september'),
        t('october'),
        t('november'),
        t('december')
    ], [t]);

    return useCallback((date = new Date()) => {
        const currentDate = getDate(date)
            .split('-')
            .reverse();

        // Trim 0 digit from beginning
        currentDate[0] = currentDate[0][0] === '0' ? currentDate[0][1] : currentDate[0];

        // Adding right suffix to days
        currentDate[0] += suffixes[currentDate[0]] || 'th';

        currentDate[1] = monthsList[formatNumber(currentDate[1] - 1)];

        return currentDate.join(' ');
    }, [formatNumber, getDate, monthsList]);
};
